import { Pencil, RefreshCw, BarChart3 } from 'lucide-react'
import type { CustomerProblemData } from '@ispot/shared'

interface Props {
  problem?: CustomerProblemData
  canSynthesize: boolean
  onSynthesize: () => void
  onEdit: (statement: string) => void
}

export function CustomerProblemSection({ problem, canSynthesize, onSynthesize, onEdit }: Props) {
  if (!problem) {
    return (
      <div className="mt-4">
        <h4 className="text-[10px] font-semibold text-text-muted uppercase tracking-wider mb-2">Customer Problem</h4>
        <div className="p-4 rounded-lg bg-warm-50 border border-border-subtle text-center">
          {canSynthesize ? (
            <>
              <p className="text-sm text-text-muted mb-2">Ready to synthesize from pains and gains</p>
              <button onClick={onSynthesize} className="text-sm font-medium text-market hover:text-market-dark transition-colors">
                Synthesize with AI
              </button>
            </>
          ) : (
            <p className="text-sm text-text-muted">Add at least 2 pains and 1 gain to synthesize</p>
          )}
        </div>
      </div>
    )
  }

  return (
    <div className="mt-4">
      <h4 className="text-[10px] font-semibold text-text-muted uppercase tracking-wider mb-2">Customer Problem</h4>
      <div className="p-4 rounded-lg bg-warm-50 border-l-3 border-l-market border border-border-subtle">
        <p className="text-[13px] text-text-secondary leading-relaxed italic">"{problem.statement}"</p>
        <div className="flex items-center gap-3 mt-3">
          <button className="flex items-center gap-1 text-[12px] text-text-muted hover:text-text-secondary transition-colors">
            <Pencil className="w-3 h-3" /> Edit
          </button>
          <button onClick={onSynthesize} className="flex items-center gap-1 text-[12px] text-text-muted hover:text-text-secondary transition-colors">
            <RefreshCw className="w-3 h-3" /> Re-synthesize
          </button>
          <button className="flex items-center gap-1 text-[12px] text-market hover:text-market-dark transition-colors">
            <BarChart3 className="w-3 h-3" /> Generate VP Canvas
          </button>
        </div>
        <p className="text-[11px] text-text-muted mt-2">
          Source: {problem.source.replace('_', ' ')} · Based on {problem.contributingPainIds.length} pains + {problem.contributingGainIds.length} gains
        </p>
      </div>
    </div>
  )
}
